export { JobStatus } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/job';

// TODO: move to SDK and remove current file
export enum JobTypes {
  Transcode = 'urn:job:av.transcode',
  Package = 'urn:job:av.package',
  ArchiveCreate = 'urn:job:archive.create',
  ArchiveExtract = 'urn:job:archive.extract',
  ImportFile = 'urn:job:import.file',
}
